import { ViewProps } from 'react-native'

import { useNavigation } from '@react-navigation/native'
import { BankPageErrorMessage } from '@zet/common/components/bankPageErrorMessage'
import { BankPageSuccessMessage } from '@zet/common/components/bankPageSuccessMessage'
import { PopupFullScreen } from '@zet/common/components/popupFullScreen'
import { colors as zetColors } from '@zet/design-system'
import { Button } from '@zet/design-system/button'
import { Icon } from '@zet/design-system/icons'
import { Stack } from '@zet/design-system/layout'
import { useUserContext } from '@zet/feature-user'
import { i18n } from '@zet/localization'
import { DEVICE_HEIGHT } from '@zet/utils/Constants'

interface PopupAddBankAccountType extends ViewProps {
  isError: boolean
  popupControl: () => void
}

export const PopupAddBankAccount = ({
  isError,
  popupControl,
}: PopupAddBankAccountType) => {
  const { refetch } = useUserContext()
  const navigation = useNavigation()

  return (
    <PopupFullScreen handlePopupClose={popupControl}>
      <Stack
        className="bg-neutral-white100 w-full justify-between px-3"
        style={{ height: DEVICE_HEIGHT }}
      >
        <Stack className="mt-32 items-center">
          <Stack>
            <Icon type="BankFilled" size={105} color="#6DB6FF" />
            <Stack className="absolute bottom-0 right-0 rounded-3xl bg-white">
              <Icon
                type={isError ? 'ErrorFilled' : 'DoneFilled'}
                size={38}
                color={isError ? zetColors.error[100] : zetColors.success[100]}
              />
            </Stack>
          </Stack>
          {isError ? (
            <BankPageErrorMessage />
          ) : (
            <BankPageSuccessMessage type={'Bank'} />
          )}
        </Stack>
        <Stack className="my-3">
          <Button
            intent={'primary'}
            size={'lg'}
            fullWidth={true}
            onPress={() => {
              refetch()

              navigation.goBack()
            }}
            eventName="click_action"
            eventPayload={{
              item_name: 'home_page_add_bank_details_close',
              type: 'bank',
            }}
          >
            {i18n.t('done')}
          </Button>
        </Stack>
      </Stack>
    </PopupFullScreen>
  )
}
